module.exports = __webpack_public_path__ + "img/政策与制度_03.33a09820.jpg";